export default "__VITE_ASSET__Df5_WRda__"